export const DEBUG = {
  getPersonList:[
    {
      name:'sanqiu',
      mobile:'182*****652',
      tentName:'浙江省',
      unitName:'sanqiu',
      departmentNames:'sanqiu',
      createDate:1665815291874,
      sourceDesc:'sanqiu',
      statusDesc:'sanqiu',
    }
  ]



};
